import { useTranslation } from 'react-i18next';
import CobaltLogo from '../../assets/images/cobalt-logo.png';
import RolesSwitch from './RolesSwitch';

export function HeaderCobalt(): JSX.Element {
  const [translation] = useTranslation();

  return (
    <div className="flex h-62px justify-between items-center">
      <div className="flex flex-row items-center">
        <img className="object-none w-147px" src={CobaltLogo} />
        <div className="pr-20px"></div>
        <div className="bg-main-ui-blue px-7px text-16px text-white font-extrabold">
          {translation('DATAPRO')}
        </div>
      </div>
      <RolesSwitch />
    </div>
  );
}
